import { render } from "./Applications.vue?vue&type=template&id=1b6442c6"
import script from "./Applications.vue?vue&type=script&lang=js"
export * from "./Applications.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__